// extracted by mini-css-extract-plugin
module.exports = {"filterBar":"_12323","location":"_18569","text":"_18784","arrow":"_2937","search":"_8936","icon":"_4288","input":"_1702","main":"_16776","item":"_5316"};